import { useCurrentUser, User } from '@economic/react-app';
import React from 'react';
import { useLocation } from 'react-router-dom';

declare global {
    interface Window {
        Intercom: any;
    }
}

const createUserSettings = (user: User): Record<string, boolean | string> => {
    const { intercomProfile } = user.extra;
    return {
        ...intercomProfile,
        hide_default_launcher: true,
        alignment: 'right',
        Url: window.location.href,
        api_base: 'https://api-iam.eu.intercom.io',
    };
};

// later maybe we should think about using a react component with provider
// https://www.npmjs.com/package/react-use-intercom

function Intercom({ children }: any) {
    const [visible, setVisibility] = React.useState(false);
    const location = useLocation();
    const user = useCurrentUser();

    React.useEffect(() => {
        if (!window.Intercom) {
            const settings = createUserSettings(user);
            window.Intercom = function () {
                // eslint-disable-next-line prefer-rest-params
                window.Intercom.c(arguments); // FIXME: don't use arguments!
            };
            window.Intercom.q = [];
            window.Intercom.c = function (args) {
                window.Intercom.q.push(args);
            };

            const script = document.createElement('script');
            script.async = true;
            script.src = `https://widget.intercom.io/widget/${settings.app_id}`;
            script.onload = () => {
                window.Intercom('boot', settings);
                window.Intercom('onHide', () => setVisibility(false));
            };
            document.head.appendChild(script);
        }

        return () => {
            if (window.Intercom) {
                window.Intercom('shutdown');
            }
        };
    }, []);

    React.useEffect(() => {
        // the intercom request can block rendering and cause pauses when the url changes in quick succession,
        // only trigger the updpate when we're 'sure' the user is staying on the current page
        const timeout = setTimeout(() => {
            window.Intercom('update', { Url: window.location.href });
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [location.pathname]);

    React.useEffect(() => {
        window.Intercom(visible ? 'show' : 'hide');
    }, [visible]);

    return children({
        toggle: () => setVisibility(!visible),
        show: () => setVisibility(true),
        hide: () => setVisibility(false),
    });
}

export function showIntercom() {
    window.Intercom('show');
}

export default Intercom;
